var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading && _vm.user)?_c('default-layout',[_c('PageLoader')],1):(_vm.loading)?_c('PageLoader'):_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('PopinNotification',{ref:"notification",attrs:{"text":_vm.notificationMessage}}),_c('ContextualMenu'),_c('BuildingCollectionModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }